module.exports = __webpack_public_path__ + "static/img/bs_content2.981097f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs_content2.png
// module id = NB6g
// module chunks = 0